import { __assign } from "tslib";
import React, { useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { Popper, PopperManager } from '../../../../Popover';
import { usePopover } from '../../../../Popovers/redux/hooks';
import { PopoverType } from '../../../../Popovers/redux/types';
import { getDeviationNotificationQueue } from '../../../../DeviationPage/redux/helpers';
import AddToCollectionPopover from '../../../_partials/AddToCollectionPopup';
import FavouriteButton from '../FavouriteButton';
import FavouriteButtonContainer from '../FavouriteButton.container';
var FavouriteButtonInContainer = FavouriteButtonContainer(FavouriteButton);
var FavouriteButtonWithPopover = function (props) {
    var _a;
    var isMobile = useContext(MobileContext);
    var actionBarType = props.actionBarType;
    var _b = usePopover(actionBarType === 'primary'
        ? PopoverType.ADD_TO_COLLECTION_PRIMARY
        : PopoverType.ADD_TO_COLLECTION_SECONDARY), popover = _b.popover, removePopover = _b.removePopover, togglePopover = _b.togglePopover;
    return (React.createElement(PopperManager, { renderReference: function (_a) {
            var ref = _a.ref;
            return (React.createElement("div", { ref: ref },
                React.createElement(FavouriteButtonInContainer, __assign({}, props, { onArrowClick: togglePopover }))));
        } },
        React.createElement(Popper, { isOpen: popover.isOpen, placement: "top", usePortal: true, positionOnly: true, modifiers: {
                offset: {
                    offset: '0, 20',
                },
            }, onClickOutside: isMobile ? undefined : removePopover },
            React.createElement(AddToCollectionPopover, { collectibleDeviation: props.deviation, notificationQueue: getDeviationNotificationQueue(props.deviation), ignorePreselectedCollections: (_a = popover.params) === null || _a === void 0 ? void 0 : _a.ignorePreselectedCollections, onClose: removePopover }))));
};
FavouriteButtonWithPopover.displayName = 'FavouriteButtonWithPopover';
export default FavouriteButtonWithPopover;
//# sourceMappingURL=FavouriteButtonWithPopover.js.map